import React from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import appearAnimationClasses from 'swag-client-common/components/ecommerce-header/appear.anim.scss';
import FilterControllers from './components/filter-controllers';
import classes from './mobile-filters-row-panel.scss';
const MobileFiltersRowPanel = ({
  filter,
  shouldShowFiltersPanel,
  isFilterPopupOpen,
  onDeleteActiveFilter,
  onClearFilters
}) => {
  const filterKeys = Object.keys(filter).sort(key => key === 'categoryId' ? -1 : 1);
  return /*#__PURE__*/React.createElement(CSSTransition, {
    in: Boolean(filterKeys.length) && shouldShowFiltersPanel,
    timeout: 255,
    classNames: appearAnimationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.mobileSelectedFiltersContainer, {
      [classes.containerWithOpenedFilterPopup]: isFilterPopupOpen
    })
  }, /*#__PURE__*/React.createElement(FilterControllers, {
    filter: filter,
    onDeleteActiveFilter: onDeleteActiveFilter,
    onClearFilters: onClearFilters
  })));
};
export default MobileFiltersRowPanel;